export enum SquareModelColorStatus {
    NOT_FULL,
    SAME,
    DIFFERENT
}